import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavLogo',
  props: {
  imgClass: {
    type: String,
    default: 'h-10',
  },
},
  setup(__props) {


const appStore = useStore.app;

const { logoHorizontal } = useStore.backend.clientCompany.imageSettings;




return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: _unref(appStore).homeRoute,
    class: "my-auto"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _unref(logoHorizontal),
        alt: "logo",
        class: _normalizeClass(__props.imgClass)
      }, null, 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})